// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon__icon___1nNH-","iconSmall":"Icon__iconSmall___1BFyd","iconBig":"Icon__iconBig___1LZVb"};